import React from 'react';
import {useTranslation} from 'react-i18next';

import styles from './modal-base.module.css';

const VisaModal = () => {
  const {t} = useTranslation();

  return (
    <>
      <h3 className={styles.modalTitle}>
        {t('fifa2022.useFullMaterialsWidget.visa.modal.title')}
      </h3>
      <p className={styles.modalText}>
        {t('fifa2022.useFullMaterialsWidget.visa.modal.text1')}
      </p>
      <p className={styles.modalText}>
        {t('fifa2022.useFullMaterialsWidget.visa.modal.text2')}
      </p>
      <a
        className={styles.modalLink}
        href="https://www.qatarimmigration.org/check-requirements/kazakhstan"
        target="_blank"
        rel="noreferrer"
      >
        {t('fifa2022.useFullMaterialsWidget.visa.modal.buttonText')}
      </a>
    </>
  );
};

export default VisaModal;
